// components/DynamicMetaTags.js
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import { getAppName } from '../utils/domainUtils'

function DynamicMetaTags ({ 
  title, 
  description, 
  pageTitle 
}) {
  const location = useLocation()
  const appName = getAppName()
  
  // Generiere den vollständigen Title
  const fullTitle = pageTitle 
    ? `${pageTitle} - ${appName}`
    : `${appName} - KI-gestützte Wissensdatenbank für Servicetechniker`
  
  // Standard Description, falls keine übergeben wurde
  const metaDescription = description || 
    `Die intelligente Wissensdatenbank für Servicetechniker. Sparen Sie Zeit, reduzieren Sie Standzeiten und bewahren Sie wertvolles Know-how – auch bei Mitarbeiterwechsel. KI-gestützte Suche, zentrale Wissensdatenbank, DSGVO-konform.`
  
  // Generiere die aktuelle URL
  const currentUrl = window.location.origin + location.pathname
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={metaDescription} />
      <meta
        name="keywords"
        content="Wissensdatenbank, Servicetechniker, KI-Suche, Troubleshooting, Fehlercode, Service-Manual, Wissensmanagement, Field Service, Techniker-Wissen, Knowledge Base, DSGVO, Azure Deutschland"
      />
      <meta name="author" content={appName} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="German" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:site_name" content={appName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />

      {/* Canonical URL */}
      <link rel="canonical" href={currentUrl} />

      {/* Additional SEO Tags */}
      <meta name="theme-color" content="#1976d2" />
    </Helmet>
  )
}

export default DynamicMetaTags

